import React, { useCallback } from "react";
import logo from "../../assets/images/icons/pg-hdr-logo-ikea.svg";
import { Container, Nav, Navbar, NavDropdown } from "react-bootstrap";
import { NavLink, useNavigate } from "react-router-dom";
import { useMsal } from "@azure/msal-react";

export default function Header() {
  const {instance} = useMsal();
  const navigate = useNavigate();
  
  /**
   * Handles the logout button click event
   * it will trigger the logoutPopup method from the MSAL instance
   */
  const handleLogout = useCallback(() => {
    instance.logoutRedirect({ postLogoutRedirectUri: "/login" }).catch((error: any) => {
        console.error(error);
    });
    navigate("/");
  }, [instance,navigate]);

  return (
    <header id="pg-hdr">
      <div className="pg-hdr-wrapper">
        <Navbar expand="lg" className="navbar-custom">
          <Container fluid>
              <div className="navbar-primary">
                  <Navbar.Brand as="div">
                      <img src={logo} alt="IKEA" title="IKEA" />
                  </Navbar.Brand>
                <div className="navbar-title">AutoMail</div>
            </div>
            <Navbar.Toggle aria-controls="navbarSupportedContent" />
            <Navbar.Collapse id="navbarSupportedContent">
              <Nav className="nav-main" as="ul">
                <NavDropdown
                    title={
                      <>
                        <span className="icon"></span>
                        <span className="text">Envois</span>
                      </>
                    }
                    id="nav-dropdown-envois"
                    as="li"
                    className="mailings"
                >              
                  <NavDropdown.Item
                    className="mailings"
                    as={NavLink}
                    to="/mailing-rules"
                  >
                    <span className="icon"></span>
                    <span className="text">Envois configurés</span>
                  </NavDropdown.Item>
                  <NavDropdown.Divider />
                  <NavDropdown.Item
                    className="mailings-add"
                    as={NavLink}
                    to="/mailing-rules/new"
                  >
                    <span className="icon"></span>
                    <span className="text">Nouvelle configuration d'envoi</span>
                  </NavDropdown.Item>
                  <NavDropdown.Divider />
                  <NavDropdown.Item
                    className="mailings-templates"
                    as={NavLink}
                    to="/templates"
                  >
                    <span className="icon"></span>
                    <span className="text">Templates email</span>
                  </NavDropdown.Item>
                  <NavDropdown.Item
                    className="mailings-media"
                    as={NavLink}
                    to="/media"
                  >
                    <span className="icon"></span>
                    <span className="text">Média</span>
                  </NavDropdown.Item>
                  <NavDropdown.Item
                    className="mailings-attachs"
                    as={NavLink}
                    to="/documents"
                  >
                    <span className="icon"></span>
                    <span className="text">Pièces jointes</span>
                  </NavDropdown.Item>
                  <NavDropdown.Divider />
                  <NavDropdown.Item
                    className="mailings-history"
                    as={NavLink}
                    to="/mails"
                  >
                    <span className="icon"></span>
                    <span className="text">Historique</span>
                  </NavDropdown.Item>
                </NavDropdown>

                <NavDropdown
                    title={
                      <>
                        <span className="icon"></span>
                        <span className="text">Paramètres</span>
                      </>
                    }
                    id="nav-dropdown-envois"
                    as="li"
                    className="parameters"
                >
                  <NavDropdown.Item
                    className="parameters-articles"
                    as={NavLink}
                    to="/products"
                  >
                    <span className="icon"></span>
                    <span className="text">Base articles</span>
                  </NavDropdown.Item>
                </NavDropdown>
                <Nav.Link as={NavLink} to="/reporting" className="nav-link reporting">
                  <span className="icon"></span>
                  <span className="text">Reporting</span>
                </Nav.Link>
              </Nav>
              <Nav className="navbar-nav nav-user" as="ul">
                <NavDropdown
                    title={
                      <>
                        <span className="icon"></span>
                        <span className="text">{instance.getActiveAccount()?.username}</span>
                      </>
                    }
                    id="nav-dropdown-user"
                    className="user"
                    as="li"
                >
                  <NavDropdown.Item onClick={handleLogout} className="signout">
                    <span className="icon"></span>
                    <span className="text">Se déconnecter</span>
                  </NavDropdown.Item>
                </NavDropdown>
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
      </div>
    </header>
  );
}